(function () {
  var request;
  function loadGallery(menu) {
    if (!window.matchMedia('(min-width:1025px)').matches) return;
    var mounts = Array.from(menu.querySelectorAll('[data-hfb-menu-gallery]:not([data-loaded]):not([data-loading])'));
    if (!mounts.length) return;
    mounts.forEach(function (mount) { mount.setAttribute('data-loading', ''); });
    if (!request) {
      var url = new URL(window.Shopify.routes.root, location.origin);
      url.searchParams.set('view', 'hfb-navigation');
      request = fetch(url.href, { credentials:'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Menu unavailable');
        return response.text();
      }).then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); }).catch(function (error) { request = null; throw error; });
    }
    request.then(function (source) {
      mounts.forEach(function (mount) {
        var key = mount.getAttribute('data-hfb-menu-gallery');
        var original = Array.from(source.querySelectorAll('[data-hfb-menu-gallery]')).find(function (node) { return node.getAttribute('data-hfb-menu-gallery') === key; });
        if (!original) throw new Error('Menu unavailable');
        var fragment = document.createDocumentFragment();
        Array.from(original.childNodes).forEach(function (node) { fragment.appendChild(document.importNode(node, true)); });
        mount.replaceChildren(fragment);
        mount.querySelectorAll('img[data-src]').forEach(function (image) { image.src = image.getAttribute('data-src'); });
        var carousel = window.jQuery && window.jQuery(mount).find('.tt-menu-slider');
        if (carousel && carousel.length && window.jQuery.fn.slick && !carousel.hasClass('slick-initialized')) carousel.slick({ dots:false, arrows:true, infinite:true, speed:300, slidesToShow:3, slidesToScroll:3, adaptiveHeight:true });
        mount.setAttribute('data-loaded', '');
        mount.removeAttribute('data-loading');
      });
    }).catch(function () { mounts.forEach(function (mount) { mount.removeAttribute('data-loading'); }); });
  }
  ['pointerover','focusin'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      var menu = event.target.closest && event.target.closest('header .tt-desctop-menu li.dropdown');
      if (menu && menu.querySelector('[data-hfb-menu-gallery]')) loadGallery(menu);
    }, { passive:true });
  });
})();
